import { render, staticRenderFns } from "./CrawlSpot.vue?vue&type=template&id=d5255ab6&lang=pug"
import script from "./CrawlSpot.vue?vue&type=script&lang=js"
export * from "./CrawlSpot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports